export const LANGUAGE_EXTENSIONS: Record<string, string> = {
  javascript: "js",
  typescript: "ts",
  python: "py",
  java: "java",
  go: "go",
  rust: "rs",
  ruby: "rb",
  php: "php",
  css: "css",
  html: "html",
  json: "json",
  yaml: "yaml",
  yml: "yaml",
  markdown: "md",
  sql: "sql",
  shell: "sh",
  bash: "sh",
  c: "c",
  cpp: "cpp",
  csharp: "cs",
  swift: "swift",
  kotlin: "kt",
  scala: "scala",
  r: "r",
  lua: "lua",
  perl: "pl",
  dockerfile: "dockerfile",
  makefile: "makefile",
  xml: "xml",
  toml: "toml",
};

// Regex to match collapsible markers: <<COLLAPSIBLE title="...">>content<</COLLAPSIBLE>>
export const COLLAPSIBLE_REGEX =
  /<<COLLAPSIBLE title="[^"]+">>.+?<<\/COLLAPSIBLE>>/gs;
